export interface HelpFrontmatter {
    title: string;
    keywords: string[];
    related: string[];
    updatedAt: string | null;
}

export interface ParsedHelpDoc {
    frontmatter: HelpFrontmatter;
    body: string;
}

const FRONTMATTER_RE = /^---\r?\n([\s\S]*?)\r?\n---\r?\n?([\s\S]*)$/;

function splitCsv(value: string): string[] {
    const trimmed = value.trim();
    if (!trimmed) {
        return [];
    }

    if (trimmed.startsWith('[') && trimmed.endsWith(']')) {
        return trimmed
            .slice(1, -1)
            .split(',')
            .map((v) => v.trim().replace(/^["']|["']$/g, ''))
            .filter(Boolean);
    }

    return trimmed
        .split(',')
        .map((v) => v.trim())
        .filter(Boolean);
}

export function parseHelpDoc(raw: string): ParsedHelpDoc {
    const match = FRONTMATTER_RE.exec(raw);

    if (!match) {
        return {
            frontmatter: { title: '', keywords: [], related: [], updatedAt: null },
            body: raw,
        };
    }

    const fmRaw = match[1] ?? '';
    const body = match[2] ?? '';
    const fm: HelpFrontmatter = { title: '', keywords: [], related: [], updatedAt: null };

    for (const line of fmRaw.split(/\r?\n/)) {
        const colonIndex = line.indexOf(':');
        if (colonIndex === -1) {
            continue;
        }

        const key = line.slice(0, colonIndex).trim();
        const value = line.slice(colonIndex + 1).trim();

        switch (key) {
            case 'title':
                fm.title = value.replace(/^["']|["']$/g, '');
                break;
            case 'keywords':
                fm.keywords = splitCsv(value);
                break;
            case 'related':
                fm.related = splitCsv(value);
                break;
            case 'updatedAt':
                fm.updatedAt = value.replace(/^["']|["']$/g, '') || null;
                break;
        }
    }

    return { frontmatter: fm, body };
}
